export default "__VITE_ASSET__CBi1DAj1__"